import { createReducer, on, Action } from '@ngrx/store';
import * as ProxyGroupActions from '../proxy-group/proxy-group.action';
import { IGroupResult } from 'src/app/models/proxy-group';

export const initialState: IGroupResult = {};

const reducer = createReducer(
  initialState,
  on(ProxyGroupActions.SuccessGetProxyGroupsApiAction, (state, { groupObj }) => state = groupObj),
  on(ProxyGroupActions.ClearProxyGroupObjectAction, (state) => state = initialState),
);

export function ProxyGroupReducer(state: IGroupResult | undefined, action: Action) {
  return reducer(state, action);
}


